// extracted by mini-css-extract-plugin
module.exports = {"section":"app-store-rating_section__MBZMD","rating":"app-store-rating_rating__Px_q9","reviews":"app-store-rating_reviews__2_mQa"};